import API from "./api";
import API_ROUTES from "./apiRoutes";

class MasterEntitiesService {
  // 0. Master Roles (DB + Settings)
  async getRoles(params = {}) {
    const res = await API.get(API_ROUTES.masters.roles, { params });
    return res.data?.data || [];
  }

  // 1. Property Types
  async getPropertyTypes() {
    const res = await API.get(API_ROUTES.masters.propertyTypes);
    return res.data?.data || [];
  }

  async createPropertyType(payload) {
    const res = await API.post(API_ROUTES.masters.createPropertyType, payload);
    return res.data?.data;
  }

  async updatePropertyType(id, payload) {
    const res = await API.put(API_ROUTES.masters.updatePropertyType(id), payload);
    return res.data?.data;
  }

  async deletePropertyType(id) {
    const res = await API.delete(API_ROUTES.masters.deletePropertyType(id));
    return res.data;
  }

  // 2. Master Delivery Companies
  async getDeliveryCompanies() {
    const res = await API.get(API_ROUTES.masters.deliveryCompanies);
    return res.data?.data || [];
  }

  async createDeliveryCompany(formData) {
    const res = await API.post(API_ROUTES.masters.deliveryCompanies, formData);
    return res.data?.data;
  }

  async updateDeliveryCompany(id, formData) {
    const res = await API.put(API_ROUTES.masters.updateDeliveryCompany(id), formData);
    return res.data?.data;
  }

  async deleteDeliveryCompany(id) {
    const res = await API.delete(API_ROUTES.masters.deleteDeliveryCompany(id));
    return res.data;
  }

  // 3. Master Cab Providers
  async getCabProviders() {
    const res = await API.get(API_ROUTES.masters.cabProviders);
    return res.data?.data || [];
  }

  async createCabProvider(formData) {
    const res = await API.post(API_ROUTES.masters.cabProviders, formData);
    return res.data?.data;
  }

  async updateCabProvider(id, formData) {
    const res = await API.put(API_ROUTES.masters.updateCabProvider(id), formData);
    return res.data?.data;
  }

  async deleteCabProvider(id) {
    const res = await API.delete(API_ROUTES.masters.deleteCabProvider(id));
    return res.data;
  }

  // 4. Property Specific Delivery & Cab Networks
  async getPropertyDeliveryNetwork(propertyId) {
    const res = await API.get(API_ROUTES.masters.propertyDeliveryNetwork(propertyId));
    return res.data?.data || [];
  }

  async togglePropertyDelivery(propertyId, delivery_company_id, is_enabled) {
    const res = await API.put(API_ROUTES.masters.togglePropertyDelivery(propertyId), {
      delivery_company_id,
      is_enabled
    });
    return res.data?.data;
  }

  async getPropertyCabNetwork(propertyId) {
    const res = await API.get(API_ROUTES.masters.propertyCabNetwork(propertyId));
    return res.data?.data || [];
  }

  async togglePropertyCab(propertyId, cab_provider_id, is_enabled) {
    const res = await API.put(API_ROUTES.masters.togglePropertyCab(propertyId), {
      cab_provider_id,
      is_enabled
    });
    return res.data?.data;
  }

  // 5. Industrial Property Settings
  async getIndustrialSettings(propertyId) {
    const res = await API.get(API_ROUTES.masters.industrialSettings(propertyId));
    return res.data?.data;
  }

  async updateIndustrialSettings(propertyId, settings) {
    const res = await API.put(API_ROUTES.masters.updateIndustrialSettings(propertyId), settings);
    return res.data?.data;
  }

  // 6. Locations & Departments
  async getLocations(propertyId) {
    const res = await API.get(API_ROUTES.masters.locations(propertyId));
    return res.data?.data || [];
  }

  async getDepartments(propertyId) {
    const res = await API.get(API_ROUTES.masters.departments(propertyId));
    return res.data?.data || [];
  }

  // Master Department Types (Taxonomy & Property Dropdowns)
  async getMasterDepartmentTypes(params = {}) {
    const res = await API.get(API_ROUTES.masters.departmentTypes, { params });
    return res.data?.data || [];
  }

  async createMasterDepartmentType(payload) {
    const res = await API.post(API_ROUTES.masters.departmentTypes, payload);
    return res.data?.data;
  }

  async updateMasterDepartmentType(id, payload) {
    const res = await API.put(API_ROUTES.masters.updateDepartmentType(id), payload);
    return res.data?.data;
  }

  async deleteMasterDepartmentType(id) {
    const res = await API.delete(API_ROUTES.masters.deleteDepartmentType(id));
    return res.data;
  }

  // 7. Industrial Visits
  async getIndustrialVisits(propertyId, params = {}) {
    const res = await API.get(API_ROUTES.industrial.visits, {
      params: { property_id: propertyId, ...params }
    });
    return res.data?.data || [];
  }

  async handleVisitAction(id, action, reason = "") {
    const res = await API.patch(API_ROUTES.industrial.action(id), { action, reason });
    return res.data;
  }

  async overrideVisit(id, override_reason) {
    const res = await API.patch(API_ROUTES.industrial.override(id), { override_reason });
    return res.data;
  }

  async checkInPass(id, gate_id = null) {
    const res = await API.patch(API_ROUTES.industrial.checkIn(id), { gate_id });
    return res.data;
  }

  async checkOutPass(id) {
    const res = await API.patch(API_ROUTES.industrial.checkOut(id));
    return res.data;
  }

  async getGuardDrafts(propertyId) {
    const res = await API.get(API_ROUTES.industrial.drafts, {
      params: { property_id: propertyId }
    });
    return res.data?.data || [];
  }

  async createGuardDraft(payload) {
    const res = await API.post(API_ROUTES.industrial.createDraft, payload);
    return res.data?.draft;
  }
}

export default new MasterEntitiesService();
